import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AutomatedDetectionEngine = () => {
  const [engineStatus, setEngineStatus] = useState('active');
  const [scanningRules] = useState([
    {
      id: 1,
      name: 'Minimum Wage Compliance',
      description: 'Validates all hourly rates against current PNG minimum wage',
      enabled: true,
      lastScan: new Date(),
      violationsFound: 0
    },
    {
      id: 2,
      name: 'Overtime Rate Validation',
      description: 'Ensures overtime paid at 1.5x base rate as per Employment Act',
      enabled: true,
      lastScan: new Date(),
      violationsFound: 0
    },
    {
      id: 3,
      name: 'Leave Policy Adherence',
      description: 'Monitors annual leave, sick leave, and maternity leave entitlements',
      enabled: true,
      lastScan: new Date(),
      violationsFound: 0
    },
    {
      id: 4,
      name: 'NASFUND Contribution Check',
      description: 'Validates employer and employee superannuation contributions',
      enabled: true,
      lastScan: new Date(),
      violationsFound: 0
    }
  ]);

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="p-6 border-b border-border bg-muted/30">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-heading font-semibold text-lg text-foreground mb-1">
              Automated Detection Engine
            </h3>
            <p className="text-sm text-muted-foreground">
              Continuously scanning payroll calculations, overtime compliance, and leave policies
            </p>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <div className={`w-3 h-3 rounded-full ${
                engineStatus === 'active' ? 'bg-success animate-pulse' : 'bg-muted-foreground'
              }`} />
              <span className="text-sm font-medium text-foreground capitalize">{engineStatus}</span>
            </div>
            <Button
              variant={engineStatus === 'active' ? 'outline' : 'primary'}
              size="sm"
              iconName={engineStatus === 'active' ? 'PauseCircle' : 'PlayCircle'}
              onClick={() => setEngineStatus(engineStatus === 'active' ? 'paused' : 'active')}
            >
              {engineStatus === 'active' ? 'Pause' : 'Resume'}
            </Button>
          </div>
        </div>
      </div>

      <div className="p-6">
        <h4 className="font-heading font-semibold text-base text-foreground mb-4">
          Active Detection Rules
        </h4>
        <div className="space-y-3">
          {scanningRules?.map((rule) => (
            <div key={rule?.id} className="border border-border rounded-lg p-4 hover:border-primary/50 transition-colors">
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
                    <h5 className="font-heading font-semibold text-sm text-foreground">{rule?.name}</h5>
                  </div>
                  <p className="text-xs text-muted-foreground mb-3">{rule?.description}</p>
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-1">
                      <Icon name="Clock" size={12} color="var(--color-muted-foreground)" />
                      <span className="text-xs text-muted-foreground">
                        Last scan: {rule?.lastScan?.toLocaleTimeString()}
                      </span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="AlertTriangle" size={12} color="var(--color-warning)" />
                      <span className="text-xs text-muted-foreground">
                        {rule?.violationsFound} violations
                      </span>
                    </div>
                  </div>
                </div>
                <div className={`px-3 py-1 text-xs font-medium rounded-full ${
                  rule?.enabled ? 'bg-success/10 text-success' : 'bg-muted text-muted-foreground'
                }`}>
                  {rule?.enabled ? 'ENABLED' : 'DISABLED'}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AutomatedDetectionEngine;